import React, { useEffect, useState } from "react";
import axios from "axios";
import { MDBContainer, MDBRow, MDBCol } from "mdb-react-ui-kit";
import { Button, Modal } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import {
  BiCheck,
  BiPlay,
  BiCalendar,
  BiMedal,
  BiChevronRight,
  BiTimer,
  BiTargetLock,
} from "react-icons/bi";
import { ClipLoader } from "react-spinners";
import bgImage from "../../../../../../../Assets/images/matching-plt-header-bg.png";
export default function SubscriptionInfoDetails() {
  const { id_subs } = useParams();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showLoginMessage, setShowLoginMessage] = useState(false);

  const handleClose = () => setShowLoginMessage(false);

  // 1. Récupération des données au chargement
  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_APIURL}/public/subs/g/${id_subs}`)
      .then((response) => {
        setSubscription(response.data.result);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching subscription details:", error);
        setLoading(false);
      });
  }, [id_subs]);

  // 2. Logique de commande identique à votre ancien code
  const handleClickCommander = () => {
    setLoading(true);

    const token = localStorage.getItem("access_token_story");
    if (!token) {
      setShowLoginMessage(true);
      setLoading(false);
      return;
    }

    const data = {
      itemToBuyId: id_subs,
      itemToBuyType: "ABONNEMENT",
      token: token,
    };

    axios
      .post(
        `${process.env.REACT_APP_BILLING_URL}/create-checkout-session`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
      .then((response) => {
        setLoading(false);
        // Ouvre la page de paiement dans un nouvel onglet comme demandé
        window.open(response.data.url, "_blank");
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error during checkout:", error);
      });
  };

  if (loading) {
    return (
      <div className="vh-100 d-flex justify-content-center align-items-center bg-white">
        <div className="text-center">
          <ClipLoader color="#4AAE9B" size={50} />
          <p className="mt-3 text-muted">
            Veuillez patienter quelques instants...
          </p>
        </div>
      </div>
    );
  }

  if (!subscription) {
    return (
      <div className="text-center py-5 font-bold">Abonnement introuvable.</div>
    );
  }

  // Nettoyage de la description pour l'affichage en liste
  const features = subscription.description_subs
    .split(/[\r\n\.]/)
    .map((point) => point.trim())
    .filter((point) => point.length > 0);

  return (
    <section
      className="py-5 min-vh-100"
      style={{
        // L'overlay linear-gradient permet de garder le contenu lisible
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        fontFamily: "'Plus Jakarta Sans', sans-serif",
      }}>
      <MDBContainer>
        <MDBRow className="justify-content-center">
          <MDBCol lg="10">
            {/* 💡 ALERTE CRÉDITS */}
            <div className="text-center mb-5">
              <div
                className="d-inline-flex align-items-center p-2 pe-4 bg-white shadow-sm"
                style={{ borderRadius: "100px", border: "1px solid #E0F2F1" }}>
                <div
                  className="bg-primary rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{
                    width: "35px",
                    height: "35px",
                    backgroundColor: "#4AAE9B",
                  }}>
                  <BiTimer color="white" size={20} />
                </div>
                <span className="small fw-bold" style={{ color: "#2D6A5F" }}>
                  Note : Vos crédits sont rechargés chaque mois
                </span>
              </div>
            </div>

            <MDBRow className="g-5">
              {/* --- GAUCHE : STATS BENTO --- */}
              <MDBCol lg="6">
                <div className="mb-4">
                  <h6
                    className="text-uppercase fw-bold mb-2"
                    style={{
                      color: "#4AAE9B",
                      letterSpacing: "2px",
                      fontSize: "0.8rem",
                    }}>
                    Pack Premium
                  </h6>
                  <h1
                    className="fw-bold display-4 mb-4"
                    style={{ color: "#1A3A36", letterSpacing: "-1.5px" }}>
                    {subscription.name_subs}
                  </h1>
                </div>

                <div className="d-flex flex-column gap-3">
                  <div
                    className="p-4 bg-white d-flex align-items-center shadow-sm"
                    style={{
                      borderRadius: "24px",
                      transition: "transform 0.3s",
                    }}>
                    <div
                      className="me-4 p-3 rounded-4"
                      style={{ backgroundColor: "#E0F2F1" }}>
                      <BiPlay size={30} style={{ color: "#4AAE9B" }} />
                    </div>
                    <div>
                      <h4 className="fw-bold mb-0">
                        {subscription.nbr_video} Vidéos
                      </h4>
                      <p className="text-muted small mb-0">
                        Contenus exclusifs par mois
                      </p>
                    </div>
                  </div>

                  <div
                    className="p-4 bg-white d-flex align-items-center shadow-sm"
                    style={{ borderRadius: "24px" }}>
                    <div
                      className="me-4 p-3 rounded-4"
                      style={{ backgroundColor: "#FFF3E0" }}>
                      <BiCalendar size={30} style={{ color: "#FF9800" }} />
                    </div>
                    <div>
                      <h4 className="fw-bold mb-0">
                        {subscription.nbr_workshops} Ateliers
                      </h4>
                      <p className="text-muted small mb-0">
                        Séances live par mois
                      </p>
                    </div>
                  </div>

                  <div
                    className="p-4 bg-white d-flex align-items-center shadow-sm"
                    style={{ borderRadius: "24px" }}>
                    <div
                      className="me-4 p-3 rounded-4"
                      style={{ backgroundColor: "#F3E5F5" }}>
                      <BiMedal size={30} style={{ color: "#9C27B0" }} />
                    </div>
                    <div>
                      <h4 className="fw-bold mb-0">
                        {subscription.nbr_offre} Consultations
                      </h4>
                      <p className="text-muted small mb-0">
                        Avantages et cadeaux
                      </p>
                    </div>
                  </div>
                </div>
              </MDBCol>

              {/* --- DROITE : ACTION CARD --- */}
              <MDBCol lg="6">
                <div
                  className="p-5 h-100 shadow-lg position-relative overflow-hidden bg-white"
                  style={{ borderRadius: "40px", border: "1px solid #E0F2F1" }}>
                  <BiTargetLock
                    className="position-absolute"
                    style={{
                      top: "-20px",
                      right: "-20px",
                      fontSize: "150px",
                      opacity: "0.03",
                    }}
                  />

                  <h5 className="fw-bold mb-4">Vos privilèges inclus :</h5>
                  <div className="mb-5">
                    {features.map((item, i) => (
                      <div key={i} className="d-flex align-items-center mb-3">
                        <BiCheck
                          className="me-2"
                          size={24}
                          style={{ color: "#4AAE9B" }}
                        />
                        <span className="text-secondary fw-medium">{item}</span>
                      </div>
                    ))}
                  </div>

                  <div className="mt-auto pt-4 border-top">
                    <div className="d-flex align-items-baseline mb-4">
                      <h2
                        className="display-3 fw-bold mb-0"
                        style={{ color: "#1A3A36" }}>
                        {subscription.price_subs}€
                      </h2>
                      <span className="text-muted ms-2 fw-medium">/ mois</span>
                    </div>

                    <Button
                      onClick={handleClickCommander}
                      className="w-100 py-3 shadow-none border-0 d-flex justify-content-between align-items-center px-4 mb-3"
                      style={{
                        backgroundColor: "#1A3A36",
                        borderRadius: "20px",
                        fontSize: "1.1rem",
                        fontWeight: "600",
                        transition: "all 0.3s",
                      }}
                      onMouseOver={(e) => (e.target.style.opacity = "0.9")}
                      onMouseOut={(e) => (e.target.style.opacity = "1")}>
                      Finaliser mon achat
                      <BiChevronRight size={28} />
                    </Button>
                    {/* --- REMPLACEMENT DE LA DATE PAR LA RÉASSURANCE STRIPE --- */}
                    <div className="text-center mt-3 pt-2">
                      <div
                        className="d-inline-flex align-items-center justify-content-center px-3 py-2"
                        style={{
                          backgroundColor: "#f8fafc",
                          borderRadius: "12px",
                          border: "1px solid #e2e8f0",
                        }}>
                        <svg
                          width="40"
                          height="18"
                          viewBox="0 0 40 18"
                          fill="none"
                          xmlns="http://w3.org"
                          className="me-2">
                          <path
                            d="M3.5 12.5h2.8v-5H3.5v5zm0-6.1h2.8V3.5H3.5v2.9zm6.6 6.1h2.8V6.4h-2.8v6.1zm0-7.2h2.8V3.5h-2.8v1.9z"
                            fill="#635BFF"
                          />
                          {/* Note: Ceci est une version simplifiée de l'icône Stripe pour l'exemple */}
                        </svg>
                        <span
                          className="small fw-bold"
                          style={{ color: "#64748b", fontSize: "0.75rem" }}>
                          Paiement 100% sécurisé via{" "}
                          <strong style={{ color: "#635BFF" }}>Stripe</strong>
                        </span>
                      </div>
                      <p
                        className="text-muted mt-2"
                        style={{ fontSize: "0.65rem", opacity: 0.7 }}>
                        Abonnement récurrent : facturation automatique chaque
                        mois, résiliable à tout moment.
                      </p>
                    </div>
                  </div>
                </div>
              </MDBCol>
            </MDBRow>
          </MDBCol>
        </MDBRow>
      </MDBContainer>

      {/* --- MODAL MESSAGE DE CONNEXION --- */}
      <Modal show={showLoginMessage} onHide={handleClose} centered>
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold">Connexion requise</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-4">
          <p className="text-muted fs-5">
            Veuillez vous connecter pour passer une commande et activer vos
            avantages.
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0 justify-content-center pb-4">
          <Button
            variant="light"
            onClick={handleClose}
            className="px-4 py-2 me-2"
            style={{ borderRadius: "10px" }}>
            Fermer
          </Button>
          <Link to="/login">
            <Button
              variant="primary"
              className="px-4 py-2 border-0"
              style={{ backgroundColor: "#4AAE9B", borderRadius: "10px" }}>
              Connexion
            </Button>
          </Link>
        </Modal.Footer>
      </Modal>
    </section>
  );
}
